import { VideoAspectRatio } from 'common/types/entities/VideoInterface'
import { getPaddingForRatio } from 'src/shared/utils/video-aspect-ratio'
import styled from 'styled-components'

type VideoUiProps = {
  disabledPointerEvents: boolean
  aspectRatio?: VideoAspectRatio
}

const VideoUi = styled.div<VideoUiProps>`
  'video::-internal-media-controls-download-button' {
    display: none;
  }
  'video::-webkit-media-controls-enclosure' {
    overflow: hidden;
  }
  'video::-webkit-media-controls-panel' {
    width: calc(100% + 30px);
  }

  position: relative;
  padding-top: ${p => getPaddingForRatio(p.aspectRatio)}%;

  ${p => p.disabledPointerEvents && `pointer-events: none;`}

  .react-player {
    position: absolute;
    top: 0;
    left: 0;
    overflow: hidden;
  }
`

export default VideoUi
